import React, { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import EprForm from "./epr";
import OffsettingForm from "./offsetting-form";
import ProspectingForm from "./prospecting-form";
import TransmittalForm from "./transmittal-form";
import ExplainWhyForm from "./explain-why-form";
import CcarForm from "./ccar-form";
import SoLoForm from "./so-lo-form";
import Edsr from "./edsr";
import ApiService from "../../api/apiService";
import { common } from "../../util/common";
import showSwal from "../swal";

function RequestNew() {
  const formId = useLocation();
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [formDetails, setFormDetails] = useState(null);

  const [isFormSubmitted, setFormSubmitted] = useState(false);
  const [referenceId, setReferenceId] = useState("");
  const [dateAndTime, setDateAndTime] = useState("");

  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const searchParams = new URLSearchParams(formId.search);
    const form = searchParams.get("f");
    if (form !== "" && form !== null) {
      setSelectedFormId(form);
    }
  }, [formId.search]);

  useEffect(() => {
    const getFormDetails = async () => {
      if (selectedFormId) {
        const formDetail = await ApiService.forms.getFormDetailById(
          selectedFormId,
        );
        const { success, permissions, form_details } = formDetail;

        if (!success) return showSwal(common.errors.FETCH_FORM_DETAIL_ERROR);

        const { add_page, view_page, open_page } = permissions;

        if (!add_page || !view_page || !open_page)
          return showSwal(common.errors.PERMISSION_ERROR);

        console.log("Fetched form_details:", form_details);
        setFormDetails(form_details);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    };

    getFormDetails();
  }, [selectedFormId]);

  const [copied, setCopied] = useState(false);

  const copyReference = () => {
    if (!referenceId) return;

    navigator.clipboard.writeText(referenceId);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const handleBack = () => {
    window.location.href = "/requests?p=view-requests";
  };

  const submittedForm = () => {
    return (
      <div className="success-wrapper">
        <div className="success-card">
          {/* Back Button */}
          <div className="success-back">
            <button className="back-btn" onClick={handleBack}>
              <i className="fa fa-arrow-left"></i> Back
            </button>
          </div>

          <div className="success-icon-container">
            <div className="success-icon-circle">
              <i className="fa fa-check" aria-hidden="true"></i>
            </div>
          </div>

          <div className="success-content">
            <span className="success-badge">Request Submitted</span>

            <h1>Your request has been submitted successfully</h1>

            <p className="success-description">
              Please keep the details below for your reference. You can also
              review this anytime in the <strong>My Requests</strong> tab.
            </p>

            <div className="success-details">
              {/* Reference ID with Copy */}
              <div className="success-detail-row">
                <span className="detail-label">Reference ID</span>

                <div className="detail-copy-container">
                  <span className="detail-value">{referenceId}</span>

                  <button
                    className="copy-btn"
                    onClick={copyReference}
                    title="Copy reference number"
                  >
                    <i className="fa fa-copy"></i>
                  </button>

                  {copied && <span className="copied-text">Copied!</span>}
                </div>
              </div>

              {/* Date */}
              <div className="success-detail-row">
                <span className="detail-label">Date & Time</span>
                <span className="detail-value">{dateAndTime}</span>
              </div>
            </div>

            <div className="success-note">
              <i className="fa fa-info-circle" aria-hidden="true"></i>
              <small>
                This record is also available in the “My Requests” tab.
              </small>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      {isLoading ? (
        <div className="loader--container">
          <div className="loader--"></div>
        </div>
      ) : (
        <div className="request-new-form">
          {!isFormSubmitted &&
            selectedFormId &&
            formDetails &&
            formDetails.type === "epr" && (
              <EprForm
                formDetails={formDetails}
                setFormSubmitted={setFormSubmitted}
                setReferenceId={setReferenceId}
                setDateAndTime={setDateAndTime}
              />
            )}
          {!isFormSubmitted &&
            selectedFormId &&
            formDetails &&
            formDetails.type === "offsetting" && (
              <OffsettingForm
                formDetails={formDetails}
                setFormSubmitted={setFormSubmitted}
                setReferenceId={setReferenceId}
                setDateAndTime={setDateAndTime}
              />
            )}
          {!isFormSubmitted &&
            selectedFormId &&
            formDetails &&
            formDetails.type === "prospecting" && (
              <ProspectingForm
                formDetails={formDetails}
                setFormSubmitted={setFormSubmitted}
                setReferenceId={setReferenceId}
                setDateAndTime={setDateAndTime}
              />
            )}
          {!isFormSubmitted &&
            selectedFormId &&
            formDetails &&
            formDetails.type === "transmittal" && (
              <TransmittalForm
                formDetails={formDetails}
                setFormSubmitted={setFormSubmitted}
                setReferenceId={setReferenceId}
                setDateAndTime={setDateAndTime}
              />
            )}
          {!isFormSubmitted &&
            selectedFormId &&
            formDetails &&
            formDetails.type === "explain-why" && (
              <ExplainWhyForm
                formDetails={formDetails}
                setFormSubmitted={setFormSubmitted}
                setReferenceId={setReferenceId}
                setDateAndTime={setDateAndTime}
              />
            )}
          {!isFormSubmitted &&
            selectedFormId &&
            formDetails &&
            formDetails.type === "ccar" && (
              <CcarForm
                formDetails={formDetails}
                setFormSubmitted={setFormSubmitted}
                setReferenceId={setReferenceId}
                setDateAndTime={setDateAndTime}
              />
            )}
          {!isFormSubmitted &&
            selectedFormId &&
            formDetails &&
            formDetails.type === "so-lo" && (
              <SoLoForm
                formDetails={formDetails}
                setFormSubmitted={setFormSubmitted}
                setReferenceId={setReferenceId}
                setDateAndTime={setDateAndTime}
              />
            )}
          {!isFormSubmitted &&
            selectedFormId &&
            formDetails &&
            formDetails.type === "edsr" && (
              <Edsr
                formDetails={formDetails}
                setFormSubmitted={setFormSubmitted}
                setReferenceId={setReferenceId}
                setDateAndTime={setDateAndTime}
              />
            )}
          {isFormSubmitted && submittedForm()}
        </div>
      )}
    </>
  );
}

export default RequestNew;
